<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Rating Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Rating Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              v-if="enableSearch === true"
              class="btn btn-info"
              @click="showFilter = !showFilter"
            ><i class="fa fa-filter"></i>Filter</a
            >
            <div class="card-tools">
              <router-link
                v-if="actionCreate === true"
                :to="{ name: 'RatingConfigAdd' }"
                class="btn btn-success"
              >
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0" v-if="enableSearch === true">
            <form @submit.prevent="setFilters" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-form-label col-3">Name</label>
                      <div class="col-9">
                        <input class="form-control" type="text" name="name" v-model="filter.name" placeholder="Name">
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-form-label col-3">Currency</label>
                      <div class="col-9">
                        <input class="form-control" type="text" name="currency" v-model="filter.currency"
                               placeholder="BDT or INR">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-form-label col-3">ID</label>
                      <div class="col-9">
                        <input class="form-control id" type="text" name="id" v-model="filter.id" placeholder="ID">
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-form-label col-3">Platform</label>
                      <div class="col-9">
                        <input class="form-control" type="text" name="platform" v-model="filter.platform"
                               placeholder="web or mobile">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-9 offset-md-3">
                        <button type="submit" class="btn btn-common m-2px">
                          <i class="fas fa-search"></i> Search
                        </button>
                        <button
                          type="reset"
                          class="btn btn-warning"
                          @click="resetFilter()"
                        >
                          <i class="fas fa-undo"></i> Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Rating-Plan</th>
                  <th>Activation Start</th>
                  <th>Activation End</th>
                  <th>Priority</th>
                  <th>Rating Type</th>
                  <th>Rate Amount</th>
                  <th>Currency</th>
                  <!--                    <th>Max Rate Amount</th>
                                      <th>App-ID</th>-->
                  <th class="text-right">Action</th>
                </tr>
                </thead>
                <tbody class="list">
                <tr v-for="(val, index) in list.data" :key="index">
                  <td>{{ val.id }}</td>
                  <td>{{ val.name }}</td>
                  <td>{{ val.description }}</td>
                  <td>{{ val.status }}</td>
                  <td>{{ val.rating_plan_id }}</td>
                  <td>{{ val.activation_start }}</td>
                  <td>{{ val.activation_end }}</td>
                  <td>{{ val.priority }}</td>
                  <td v-if="val.rating_type_id === 1">Base</td>
                  <td v-if="val.rating_type_id === 2">Discount</td>
                  <td>{{ val.rate }}</td>
                  <td>{{ val.currency }}</td>
                  <!--                    <td>{{ val.max_rate_amount }}</td>
                                      <td>{{ val.app_id }}</td>-->
                  <td class="text-right">
                    <router-link
                      v-if="actionView === true"
                      :to="{
                          name: 'RatingConfigShow',
                          params: { id: val.id },
                        }"
                      class="btn btn-info btn-sm m-2px"
                    >
                      <i class="fas fa-eye"></i>
                    </router-link>
                    <router-link
                      v-if="actionEdit === true"
                      :to="{
                          name: 'RatingConfigEdit',
                          params: { id: val.id },
                        }"
                      class="btn btn-info btn-sm m-2px"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <a
                      v-if="actionDelete === true"
                      class="btn btn-danger btn-sm m-2px"
                      href="javascript:void(0)"
                      @click="deleteObject(val.id, index)"
                    ><i class="fas fa-trash"></i
                    ></a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading === false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getList()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import {CBSProductRatingApi} from "@/services/api";

export default {
  name: "RatingConfig",
  components: {
    VuePagination,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    },
    enableSearch: true,
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: "",
  }),
  mounted: function () {
    this.getList()
  },
  methods: {
    getList: function () {
      this.is_loading = true
      let query = {...this.filter, ...this.$route.query}
      CBSProductRatingApi.getRatingConfig(query)
        .then((items) => {
          this.list = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    async setFilters() {
      await this.$router
        .push({
          path: this.$route.path,
          query: this.filter,
        })
        .catch(() => {})
    },
    resetFilter() {
      const query = Object.assign({}, this.$route.query)
      if(Object.keys(query).length > 0) {
        delete query.page
        this.$router.replace({  })
      }
      this.filter = {}
      this.getList()
    }
  }
}
</script>
